module.exports = __webpack_public_path__ + "img/36.7b488448.jpg";